export const MESSENGER_SLICE_NAME = 'messaging';
export const MESSENGER_BASE_API_URL = '/messaging/v3';
export const MSG_DRAWER_WIDTH = 450;
